export const SET_HISTORY = 'history/setHistory';
export const CLEAR_HISTORY = 'history/clearHistory';